import { z } from 'zod';

export const registrationCodeSchema = z.string().length(7);

export const isValidRegistrationCode = (referenceCode: string) =>
  registrationCodeSchema.safeParse(referenceCode).success;

export const phoneNumberSchema = z
  .string()
  .min(8, { message: 'page.card.invalid-phone-number' })
  .regex(/^[+\-\d\s]+$/, { message: 'page.card.invalid-phone-number' });
